import { useNavigate } from 'react-router-dom';
import { BsChevronRight } from 'react-icons/bs';
import { pushToAnalytics } from '../utils/analytics';
import { DisplayedIn, YSH_GTM_EVENTS } from '../types/types';
import '../scss/show-all-offers-link.scss';

interface Props {
  displayedIn: DisplayedIn;
}

const ShowAllOffersLink: React.FC<Props> = ({ displayedIn }) => {
  const navigate = useNavigate();

  const getLinkTo = () => {
    const params = new URLSearchParams();

    if (displayedIn === 'Preporučujemo') {
      params.set('recommended', '1');
    }

    if (displayedIn === 'Aktuelne ponude') {
      params.set('current', '1');
    }

    if (displayedIn === 'Najpopularnije') {
      params.set('sort', 'popular');
    }

    if (displayedIn === 'Najveći popusti') {
      params.set('sort', 'discount');
    }

    if (displayedIn === 'Najnovije ponude') {
      params.set('newest', '1');
    }

    if (displayedIn === 'Yettel_sve') {
      params.set('is_advantage', '1');
    }

    if (displayedIn === 'Uskoro dostupno') {
      params.set('coming_soon', '1');
    }

    return `/ponude?${params.toString()}`;
  };

  const handleClick = () => {
    pushToAnalytics({
      eventName: YSH_GTM_EVENTS.SELECT_COUPON_SECTION,
      placement: `Homepage - ${displayedIn}`,
      data: {
        coupon_details: {
          coupon_list_id: `Homepage - ${displayedIn}`,
          coupon_list_name: `Homepage - ${displayedIn}`
        }
      }
    });

    navigate(getLinkTo());
  };

  return (
    <section className="offer mb-2 show-all-offers-link cursor-pointer" onClick={handleClick}>
      <div className="show-all-offers-container">
        <p className="font-yettel-bold mb-2">Pogledaj sve</p>
        <div className="show-all-offers__button">
          <div className="show-all-offers__button__inner">
            <BsChevronRight />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ShowAllOffersLink;
